export default "__VITE_ASSET__DZ6I2a5T__"